export default __webpack_public_path__ + "static/media/fad-logo-rewire.cade3a07.svg";